import { render, staticRenderFns } from "./RideitPassengerTokenCard.vue?vue&type=template&id=3968a922&scoped=true"
import script from "./RideitPassengerTokenCard.vue?vue&type=script&lang=ts"
export * from "./RideitPassengerTokenCard.vue?vue&type=script&lang=ts"
import style0 from "./RideitPassengerTokenCard.vue?vue&type=style&index=0&id=3968a922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968a922",
  null
  
)

export default component.exports